import React, { createContext, useContext, ReactNode } from 'react';
import { useLocalization } from '../hooks/useLocalization';

interface LocalizationContextType {
    language: string;
    setLanguage: (lang: 'ru' | 'en') => void;
    t: (key: string, params?: Record<string, string | number>) => string;
    tHtml: (key: string, params?: Record<string, string | number>) => ReactNode;
}

const LocalizationContext = createContext<LocalizationContextType | undefined>(undefined);

interface LocalizationProviderProps {
    children: ReactNode;
}

export const LocalizationProvider: React.FC<LocalizationProviderProps> = ({ children }) => {
    const localization = useLocalization();

    return (
        <LocalizationContext.Provider value={localization}>
            {children}
        </LocalizationContext.Provider>
    );
};

export const useTranslation = (): LocalizationContextType => {
    const context = useContext(LocalizationContext);
    if (context === undefined) {
        throw new Error('useTranslation must be used within a LocalizationProvider');
    }
    return context;
};